import { VStack } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/spinner";
import { Card, NumberInput } from "@components/ui-kit";
import { Select, Trans, t } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import { fieldToInputProps } from "@src/utils/forms/inputHelpers";
import { useStore as useAppStore } from "@src/utils/hooks";
import cs from "classnames";
import { observer } from "mobx-react-lite";
import { useStore } from "../store";

export const SummaryCard = observer(function SumCard() {
  const { workspaceStore } = useAppStore();
  const store = useStore();

  if (!store.selectedCurrency) {
    return null;
  }

  return (
    <Card w="full" overflow="hidden">
      <div className="bg-gray-100">
        <Card.Section>
          <div>
            <div className="flex items-center justify-between">
              <h2 className="font-bold text-2xl">
                <Select
                  value={
                    store.form.total_amount_includes_vat.value
                      ? "withVat"
                      : "withoutVat"
                  }
                  _withVat="Total expense (with VAT)"
                  other="Total expense"
                />
              </h2>
              <div className="font-bold text-4xl">
                {((store.convertAmountFetcher.isLoading.value ||
                  store.exchangeRateFetcher.isLoading.value) && (
                  <Spinner size="sm" />
                )) ||
                  (store.convertedAmount !== undefined &&
                    currency.formatByWorkspace(store.convertedAmount))}
              </div>
            </div>
            <div className="flex justify-end mt-6">
              {store.isUsedDifferentCurrency && (
                <NumberInput
                  currency
                  label={t`Exchange rate`}
                  prefix={`1 ${workspaceStore.settings?.currency.code} =`}
                  suffix={store.selectedCurrency?.code}
                  prefixStyles={{ w: 16 }}
                  inputStyle={{ paddingLeft: 16 }}
                  {...fieldToInputProps(store.form.exchange_rate)}
                  value={store.form.exchange_rate.value?.toString() ?? ""}
                />
              )}
            </div>
            <div className="flex items-center justify-between mt-6">
              <div>
                <Select
                  value={
                    store.form.total_amount_includes_vat.value
                      ? "withVat"
                      : "withoutVat"
                  }
                  _withVat="Actual budget split (with VAT)"
                  other="Actual budget split"
                />
              </div>
              <div
                className={cs(
                  "font-bold text-2xl",
                  store.totalAmountOfBudgetItems === store.totalAmountForExpense
                    ? "text-green"
                    : "text-red",
                )}
                style={{ justifySelf: "end" }}
              >
                {currency.formatByCurrency(
                  store.totalAmountOfBudgetItems,
                  store.selectedCurrency,
                )}
              </div>
            </div>
            {store.showVatSelect && (
              <div className="flex items-center justify-between mt-6">
                <VStack alignItems="start">
                  <Trans>VAT split</Trans>
                  {store.vatTotalsMismatch && (
                    <span className="text-red">
                      <Trans>
                        VAT amounts on budget items must match the document VAT
                        total
                      </Trans>
                    </span>
                  )}
                </VStack>
                <div
                  className={cs(
                    "font-bold text-2xl",
                    store.vatTotalsMismatch ? "text-red" : "text-green",
                  )}
                  style={{ justifySelf: "end" }}
                >
                  {currency.formatByCurrency(
                    store.totalVatOfBudgetItems,
                    store.selectedCurrency,
                  )}
                  {store.vatTotalsMismatch && (
                    <span className="ml-2">
                      /{" "}
                      {currency.formatByCurrency(
                        store.totalVatOfVatItems,
                        store.selectedCurrency,
                      )}
                    </span>
                  )}
                </div>
              </div>
            )}
            <div className="flex items-center justify-between mt-6">
              <div>
                {store.totalRemainingAmount >= 0 ? (
                  <Select
                    value={
                      store.form.total_amount_includes_vat.value
                        ? "withVat"
                        : "withoutVat"
                    }
                    _withVat={"To allocate (with VAT)"}
                    other="To allocate"
                  />
                ) : (
                  <Select
                    value={
                      store.form.total_amount_includes_vat.value
                        ? "withVat"
                        : "withoutVat"
                    }
                    _withVat={"To reduce (with VAT)"}
                    other="To reduce"
                  />
                )}
              </div>
              <div
                className={cs(
                  "font-bold text-2xl",
                  store.totalRemainingAmount === 0 ? "text-green" : "text-red",
                )}
                style={{ justifySelf: "end" }}
              >
                {store.convertAmountFetcher.isLoading.value ||
                store.exchangeRateFetcher.isLoading.value ? (
                  <Spinner size="sm" />
                ) : store.convertedAmount !== undefined ? (
                  currency.formatByCurrency(
                    store.totalRemainingAmount,
                    store.selectedCurrency,
                  )
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        </Card.Section>
      </div>
    </Card>
  );
});
